module.exports = __webpack_public_path__ + "static/media/велком).c351facd.jpg";